import { createFileRoute } from "@tanstack/react-router";

import { seo } from "@/lib/seo";
import { assertDraftRouteVisible } from "@/lib/draft-routes";
import { PagePlaceholder } from "@/components/site/PagePlaceholder";

export const Route = createFileRoute("/_site/guides/business-plan-checklist")({
  // Draft route: 404s on the live domain, renders normally elsewhere. See src/lib/draft-routes.ts.
  beforeLoad: assertDraftRouteVisible,
  head: () =>
    seo({
      title: "Business Plan Checklist",
      description: "Every section a lender or investor expects, and what belongs in each.",
      path: "/guides/business-plan-checklist",
      noindex: true,
    }),
  component: Page,
});

function Page() {
  return <PagePlaceholder title={"Business plan checklist"} intro={"[SUPPLY: checklist content]"} />;
}
